import { React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import {
	DashboardWrapper,
	HeaderWrapper,
	CardWrapper,
	ActivitySection,
	TableSection,
	ChartCardContent,
} from "./dashboard.styled";
import { Header } from "../../components/ReusableComponents/Card.styled";
import Hand from "../../layout/assets/hand.svg";
import Calendar from "../../layout/assets/calendar.svg";
import UsersTracker from "../../components/ReusableComponents/UsersTracker";
import UserCard from "../../components/ReusableComponents/UserCard";
import Chartlabel from "../../components/ReusableComponents/Chartlabel";
import EducationCharts from "../education/Partials/EducationCharts";
import {
	TableBody,
	TableCell,
	TableRow,
	styled,
	Table,
	tableCellClasses,
	TableContainer,
	Paper,
} from "@mui/material";
import CardLayout from "../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../components/ReusableComponents/DoughnutChart";
import { getLeaseInfo, getAfInfo, getuserProfiles, walletType } from "./DashboardUtils";
import { getAllCustomers } from "../customer/customersUtils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { BiArrowBack } from "react-icons/bi";
import { DoughnutChartOptions } from "../../Constants";
import BalanceCard from "../../auth/wallet/BalanceCard";
import { useSelector } from "react-redux";
import { getCurrentUserInfo } from "../../utils/UserAuth";

function Dashboard() {
	const adminInfo = getCurrentUserInfo();
	const { adminWallet } = useSelector((state) => state.wallet);
	const [newCustomers, setNewCustomers] = useState([]);
	const [profileData, setProfileData] = useState([]);
	const [totalLease, setTotalLease] = useState(0);
	const [leaseInfo, setLeaseInfo] = useState({ leasor: 0, leasee: 0 });
	const [totalAfs, setTotalAfs] = useState(0);
	const [AfDetails, setAfDetails] = useState({ Apprentice: 0, Investors: 0 });
	const [AfData, setAfData] = useState({
		labels: ["Apprentice", "Investors"],
		datasets: [
			{
				label: "user(s)",
				data: [0, 0],
				backgroundColor: ["#006516", "#DAE7ED"],
			},
		],
	});
	const [leaseData, setLeaseData] = useState({
		labels: ["Leasor", "Lease"],
		datasets: [
			{
				label: "user(s)",
				data: [0, 0],
				backgroundColor: ["#00D19F", "#DAE7ED"],
			},
		],
	});

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	useEffect(() => {
		getLeaseData();
		getAfData();
		UserProfiles();
		getLastThreeCustomers();
	}, []);

	const getLastThreeCustomers = async () => {
		try {
			const data = await getAllCustomers();
			if (data.result) {
				const sortedData = data.result
					.filter((data) => !data.isAdmin)
					.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
				// console.log(sortedData);
				let sortedArray = sortedData.slice(0, 8);
				// console.log(sortedArray)
				setNewCustomers([
					{
						id: 1,
						title: "New customers",
						UsersList: sortedArray,
					},
				]);
			} else {
				toast.error("error fetching customers data");
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getLeaseData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const data = await getLeaseInfo();
			let info = data.result;

			if (data.result) {
				let totalLeaseUsers = parseInt(info?.leasor) + parseInt(info?.leasee);
				setTotalLease(totalLeaseUsers);
				setLeaseInfo({ leasor: info?.leasor, leasee: info?.leasee });
				setLeaseData({
					labels: ["Leasor", "Lease"],
					datasets: [
						{
							label: "user(s)",
							data: [info?.leasor, info?.leasee],
							backgroundColor: ["#00D19F", "#DAE7ED"],
						},
					],
				});
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch lease data");
		}
	};

	const getAfData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const data = await getAfInfo();

			let AfData = data.result;
			if (data.result) {
				let totalAfs = parseInt(AfData?.apprentice) + parseInt(AfData?.investor);
				setTotalAfs(totalAfs);
				setAfDetails({
					Apprentice: AfData?.apprentice,
					Investors: AfData?.investor,
				});
				setAfData({
					labels: ["Apprentice", "Investors"],
					datasets: [
						{
							label: "user(s)",
							data: [AfData?.apprentice, AfData?.investor],
							backgroundColor: ["#006516", "#DAE7ED"],
						},
					],
				});
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch AF data");
		}
	};
	//dummy data

	const UserProfiles = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const data = await getuserProfiles();
			let userProfiles = data.result;
			setProfileData([
				{
					id: 1,
					type: "Personal",
					number: userProfiles?.personal,
				},

				{
					id: 2,
					type: "Business",
					number: userProfiles?.business,
				},

				{
					id: 3,
					type: "Investors",
					number: userProfiles?.investor,
				},
			]);
		} catch (error) {
			console.error(error);
			toast.error("unable to data, please try again later");
		}
	};

	//material UI Table styles
	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: theme.palette.common.black,
			color: theme.palette.common.white,
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
			fontFamily: "Manrope",
		},
	}));

	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
		// hide last border
		"&:last-child td, &:last-child th": {
			border: 0,
		},
	}));

	function createData(time, activity, button) {
		return { time, activity, button };
	}

	const rows = [
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
		createData("just now", "Emailed new user", "view"),
	];

	const isAllowedToUseWallet = () => {
		if (adminInfo?.privileges === "firstLineApproval" && adminInfo?.role?.toLowerCase() === "finance") {
			return true;
		}
		if (adminInfo?.privileges?.toLowerCase() === "super administrator") {
			return true;
		} else {
			return false;
		}
	};

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				{isAllowedToUseWallet() && <BalanceCard wallet={mainWallet} />}
				<IntroductionHeader />
				{/* //first row */}
				<CardWrapper>
					{profileData.length <= 0 ? (
						<p>loading...</p>
					) : (
						profileData.map((data) => {
							return (
								<CardLayout key={data.id} type={data.type}>
									<UsersTracker
										key={data.id}
										type={data.type}
										year={data.year}
										number={data.number}
										rate={data.rate}
										progressType={data.progressType}
									/>
								</CardLayout>
							);
						})
					)}
				</CardWrapper>

				{/* second row */}

				<CardWrapper>
					<CardLayout type='Lease'>
						<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
							<DoughnutChart
								totalAmount={totalLease}
								data={leaseData && leaseData}
								options={DoughnutChartOptions}
							/>
							<Chartlabel
								firstColorId={"#00D19F"}
								firstCaption={"Leasor"}
								firstAmount={leaseInfo?.leasor}
								secondColorId={"#DAE7ED"}
								secondCaption={"Leasee"}
								secondAmount={leaseInfo?.leasee}
								totalAmount={totalLease}
							/>
						</ChartCardContent>
					</CardLayout>

					<CardLayout type='Apprenticeship Finance'>
						<ChartCardContent>
							<DoughnutChart data={AfData && AfData} options={DoughnutChartOptions} totalAmount={totalAfs} />
							<Chartlabel
								firstColorId={"#006516"}
								firstCaption={"Apprentice"}
								firstAmount={AfDetails?.Apprentice}
								secondColorId={"#96A2A8"}
								secondCaption={"Investors"}
								secondAmount={AfDetails?.Investors}
								totalAmount={totalAfs}
							/>
						</ChartCardContent>
					</CardLayout>

					<EducationCharts customwidth={"100%"} custommargin={"5px"} title={"Education"} />
				</CardWrapper>

				<ActivitySection>
					<TableSection>
						<Header>
							<p className='activity'>Recent Transactions</p>
							<select name='year' required defaultValue>
								<option value='' disabled defaultValue>
									Select day
								</option>
								<option value='today'>Today</option>
								<option value='yesterday'>Yesterday</option>
							</select>
						</Header>
						<TableContainer style={{ marginTop: "30px" }} component={Paper}>
							<Table sx={{ paddingTop: 40, minWidth: "350px" }} aria-label='customized table'>
								<TableBody>
									{rows.map((row, i) => (
										<StyledTableRow key={i}>
											<StyledTableCell align='left' component='th' scope='row'>
												{row.time}
											</StyledTableCell>
											<StyledTableCell align='center'>{row.activity}</StyledTableCell>
											<StyledTableCell align='right'>
												<button> {row.button}</button>
											</StyledTableCell>
										</StyledTableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</TableSection>

					<div className='users'>
						{newCustomers.length <= 0 ? (
							<p>loading...</p>
						) : (
							newCustomers.map((data, i) => {
								return <UserCard key={i} id={data.id} title={data.title} UsersList={data.UsersList} />;
							})
						)}
					</div>
				</ActivitySection>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

//intro texts
export function IntroductionHeader({ nav }) {
	const navigate = useNavigate();
	useEffect(() => {
		const currentDate = () => {
			const options = {
				weekday: "long",
				month: "long",
				day: "numeric",
				year: "numeric",
			};
			const today = new Date();
			// console.log(today.toDateString());
			const current = today.toLocaleDateString("en-US", options);
			const currentTwo = today.toDateString();
			setDate({ current, currentTwo });
			// setDate(current);
		};

		currentDate();
	}, []);
	const [date, setDate] = useState(null);

	const formatDateTwo = date?.currentTwo.split(" ");

	return (
		<HeaderWrapper>
			{nav ? (
				<div className='intro'>
					<div onClick={() => navigate(-1)} style={{ color: "#408D94" }} className='flex gap-2 border '>
						<BiArrowBack size={24} />
						<p>Go back</p>
					</div>
				</div>
			) : (
				<div className='intro'>
					<p> Hello, Admin! </p>
					<img src={Hand} style={{ height: "25px", width: "23px" }} alt='hand' />
				</div>
			)}

			<div className='date'>
				<div>
					<img src={Calendar} style={{ height: "25px", width: "25px" }} alt='calendar image' />
				</div>
				<p className='desktop-date'>{date && date?.current}</p>
				<p className='mobile-date'>
					{date && `${formatDateTwo[0]}, ${formatDateTwo[1]} ${formatDateTwo[2]}, ${formatDateTwo[3]}`}
				</p>
			</div>
		</HeaderWrapper>
	);
}

IntroductionHeader.propTypes = {
	nav: PropTypes.bool,
};

export default Dashboard;
